import { useNavigate, useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Workflow, FileText, Activity, Settings, Bot } from "lucide-react";
import ModelRouting from "@/pages/ModelRouting";
import ModelPolicies from "@/pages/ModelPolicies";
import ModelDecisions from "@/pages/ModelDecisions";
import RoutingConfig from "@/pages/RoutingConfig";
import AIProviders from "@/pages/AIProviders";

type TabKey = "overview" | "policies" | "decisions" | "config" | "providers";
const VALID: TabKey[] = ["overview", "policies", "decisions", "config", "providers"];

export default function ModelRoutingHub() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const raw = (params.get("tab") || "overview") as TabKey;
  const tab: TabKey = VALID.includes(raw) ? raw : "overview";
  const setTab = (v: string) => navigate(`/model-routing?tab=${v}`, { replace: true });

  return (
    <div className="container mx-auto px-4 py-4 max-w-7xl">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="grid w-full max-w-3xl grid-cols-5">
          <TabsTrigger value="overview" className="gap-2"><Workflow className="w-4 h-4" />Visão</TabsTrigger>
          <TabsTrigger value="policies" className="gap-2"><FileText className="w-4 h-4" />Políticas</TabsTrigger>
          <TabsTrigger value="decisions" className="gap-2"><Activity className="w-4 h-4" />Decisões</TabsTrigger>
          <TabsTrigger value="config" className="gap-2"><Settings className="w-4 h-4" />Config</TabsTrigger>
          <TabsTrigger value="providers" className="gap-2"><Bot className="w-4 h-4" />Provedores</TabsTrigger>
        </TabsList>
        <TabsContent value="overview" className="mt-2"><ModelRouting /></TabsContent>
        <TabsContent value="policies" className="mt-2"><ModelPolicies /></TabsContent>
        <TabsContent value="decisions" className="mt-2"><ModelDecisions /></TabsContent>
        <TabsContent value="config" className="mt-2"><RoutingConfig /></TabsContent>
        <TabsContent value="providers" className="mt-2"><AIProviders /></TabsContent>
      </Tabs>
    </div>
  );
}
